import client from '@/api/client';

import crudlModuleGenerator from '@/_CRUDL/modules/generator';

import { SORT_METHODS } from '@/_CRUDL/helpers/data/sort';

const PROPOSALS_VALUES_START = '_CRUDL/proposals/values/START';
const PROPOSALS_VALUES_SUCCESS = '_CRUDL/proposals/values/SUCCESS';
const PROPOSALS_VALUES_FAILURE = '_CRUDL/proposals/values/FAILURE';

const PROPOSALS_STATUS_START = '_CRUDL/proposals/status/start';
const PROPOSALS_STATUS_SUCCESS = '_CRUDL/proposals/status/success';
const PROPOSALS_STATUS_FAILURE = '_CRUDL/proposals/status/failure';

const PROPOSALS_GET_OWNERSHIP_START = '_CRUDL/proposals/get_ownership/start';
const PROPOSALS_GET_OWNERSHIP_SUCCESS = '_CRUDL/proposals/get_ownership/success';
const PROPOSALS_GET_OWNERSHIP_FAILURE = '_CRUDL/proposals/get_ownership/failure';

const PROPOSALS_LEAVE_OWNERSHIP_START = '_CRUDL/proposals/leave_ownership/start';
const PROPOSALS_LEAVE_OWNERSHIP_SUCCESS = '_CRUDL/proposals/leave_ownership/success';
const PROPOSALS_LEAVE_OWNERSHIP_FAILURE = '_CRUDL/proposals/leave_ownership/failure';

const PROPOSALS_ACTIVITY_LOG_START = '_CRUDL/proposals/activity_log/start';
const PROPOSALS_ACTIVITY_LOG_SUCCESS = '_CRUDL/proposals/activity_log/success';
const PROPOSALS_ACTIVITY_LOG_FAILURE = '_CRUDL/proposals/activity_log/failure';

export const INITIAL_PROPOSAL_FILTERS = {
  _active: false,
  CRUDL_append: false,

  customer: '',
  sort: SORT_METHODS.created_at_desc.value,

  page: 1,
  per_page: 20,

  after: '',
  before: '',

  type: 'cdc',
  states: [],
  bank_codes: [],
  store_ids: [],
  seller_ids: [],
  approved_bank_codes: [],
};

const proposals = crudlModuleGenerator('proposals', {
  customKeys: {
    create: 'complete_proposal',
  },
});

export default {
  ...proposals,
  actions: {
    ...proposals.actions,
    approved({ commit }, payload) {
      commit('_CRUDL/proposals/list/START');

      return new Promise((resolve, reject) => {
        client.get('/proposals/approved', {
          params: payload,
        })
          .then((response) => {
            commit('_CRUDL/proposals/list/SUCCESS', response);
            resolve(response);
          })
          .catch((error) => {
            commit('_CRUDL/proposals/list/FAILURE', error);
            reject(error);
          });
      });
    },
    values({ commit }, payload) {
      commit(PROPOSALS_VALUES_START);

      return new Promise((resolve, reject) => {
        client.get('/proposals/values', {
          params: {
            states: 'aprovada',
            ...payload,
          },
        })
          .then((response) => {
            commit(PROPOSALS_VALUES_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(PROPOSALS_VALUES_FAILURE, error);
            reject(error);
          });
      });
    },
    status({ commit }, payload) {
      commit(PROPOSALS_STATUS_START);

      return new Promise((resolve, reject) => {
        client.get(`/proposals/${payload.id}/${payload.status}`)
          .then((response) => {
            commit(PROPOSALS_STATUS_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(PROPOSALS_STATUS_FAILURE, error);
            reject(error);
          });
      });
    },
    get_ownership({ commit }, payload) {
      commit(PROPOSALS_GET_OWNERSHIP_START);

      return new Promise((resolve, reject) => {
        client.get(`/proposals/${payload.id}/get_ownership`)
          .then((response) => {
            commit(PROPOSALS_GET_OWNERSHIP_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(PROPOSALS_GET_OWNERSHIP_FAILURE, error);
            reject(error);
          });
      });
    },
    leave_ownership({ commit }, payload) {
      commit(PROPOSALS_LEAVE_OWNERSHIP_START);

      return new Promise((resolve, reject) => {
        client.get(`/proposals/${payload.id}/leave_ownership`)
          .then((response) => {
            commit(PROPOSALS_LEAVE_OWNERSHIP_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(PROPOSALS_LEAVE_OWNERSHIP_FAILURE, error);
            reject(error);
          });
      });
    },
    activity_log({ commit }, payload) {
      commit(PROPOSALS_ACTIVITY_LOG_START);

      return new Promise((resolve, reject) => {
        client.get(`/proposals/${payload.id}/activity_log`)
          .then((response) => {
            commit(PROPOSALS_ACTIVITY_LOG_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(PROPOSALS_ACTIVITY_LOG_FAILURE, error);
            reject(error);
          });
      });
    },
  },
  state: {
    ...proposals.state,
    list: {
      ...proposals.state.list,
      filters: {
        ...INITIAL_PROPOSAL_FILTERS,
      },
    },
    values: {
      item: {},
      error: null,
      loading: false,
    },
    status: {
      item: {},
      error: null,
      loading: false,
    },
    getOwnership: {
      error: null,
      loading: false,
    },
    leaveOwnership: {
      error: null,
      loading: false,
    },
    activityLog: {
      items: [],
      error: null,
      loading: false,
    },
  },
  mutations: {
    ...proposals.mutations,
    [PROPOSALS_VALUES_START](state) {
      state.values.item = {};
      state.values.error = null;
      state.values.loading = true;
    },
    [PROPOSALS_VALUES_SUCCESS](state, response) {
      state.values.item = response.data.values_proposal;
      state.values.error = null;
      state.values.loading = false;
    },
    [PROPOSALS_VALUES_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.values.item = {};
      state.values.error = details;
      state.values.loading = false;
    },

    [PROPOSALS_STATUS_START](state) {
      state.status.item = {};
      state.status.error = null;
      state.status.loading = true;
    },
    [PROPOSALS_STATUS_SUCCESS](state, response) {
      state.status.item = response.data.customer;
      state.status.error = null;
      state.status.loading = false;
    },
    [PROPOSALS_STATUS_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.status.item = {};
      state.status.error = details;
      state.status.loading = false;
    },

    [PROPOSALS_GET_OWNERSHIP_START](state) {
      state.getOwnership.error = null;
      state.getOwnership.loading = true;
    },
    [PROPOSALS_GET_OWNERSHIP_SUCCESS](state, response) {
      state.getOwnership.error = null;
      state.getOwnership.loading = false;

      if (state.read.item.id === response.data.proposal.id) {
        state.read.item = {
          ...state.read.item,
          ...response.data.proposal,
        };
      }
    },
    [PROPOSALS_GET_OWNERSHIP_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.getOwnership.error = details;
      state.getOwnership.loading = false;
    },

    [PROPOSALS_LEAVE_OWNERSHIP_START](state) {
      state.leaveOwnership.error = null;
      state.leaveOwnership.loading = true;
    },
    [PROPOSALS_LEAVE_OWNERSHIP_SUCCESS](state, response) {
      state.leaveOwnership.error = null;
      state.leaveOwnership.loading = false;

      if (state.read.item.id === response.data.proposal.id) {
        state.read.item = {
          ...state.read.item,
          ...response.data.proposal,
        };
      }
    },
    [PROPOSALS_LEAVE_OWNERSHIP_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.leaveOwnership.error = details;
      state.leaveOwnership.loading = false;
    },

    [PROPOSALS_ACTIVITY_LOG_START](state) {
      state.activityLog.items = [];
      state.activityLog.error = null;
      state.activityLog.loading = true;
    },
    [PROPOSALS_ACTIVITY_LOG_SUCCESS](state, response) {
      state.activityLog.items = response.data.activity_log;
      state.activityLog.error = null;
      state.activityLog.loading = false;
    },
    [PROPOSALS_ACTIVITY_LOG_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.activityLog.error = details;
      state.activityLog.loading = false;
    },
  },
};
